import { render, staticRenderFns } from "./leadsDetail.vue?vue&type=template&id=1f6818d0&scoped=true&"
import script from "./leadsDetail.vue?vue&type=script&lang=js&"
export * from "./leadsDetail.vue?vue&type=script&lang=js&"
import style0 from "./leadsDetail.vue?vue&type=style&index=0&id=1f6818d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6818d0",
  null
  
)

export default component.exports